import { upgradeTargetName } from "@highmarch/app";
import { BalanceData, PlayerProfile } from "@highmarch/domain";
import { fmtDuration } from "../format";
import { icon } from "../iconsKit";
import { barHtml, btnHtml } from "../kit";
import { describeCost } from "../gearUi";
import { BuilderPick } from "./builderPick";

/**
 * The builder row in the Towers tab (mockup 02's strip, moved off the scene): idle → the suggested upgrade, busy → bar
 * and ETA. Busy with a free queue slot and something affordable to queue (D4), its button offers QUEUE on it instead
 * of View (`queueIndex`: the tower or fortress it would queue). A pet's job (Pets v2) reads like a tower's, by its name.
 */
export function builderRowHtml(B: BalanceData, p: PlayerProfile, pick: BuilderPick, queueIndex = -1, queueLine = ""): string {
  if (pick.kind === "busy") {
    const name = upgradeTargetName(B, pick.target, pick.towerIndex);
    const title = p.buildersOwned > 1 ? "All builders busy" : "Builder busy";
    return `
      <div class="ic busy">${icon("builder", 22, "#fff8e6")}</div>
      <div class="text"><b>${title}</b><small>${name} → Lv ${pick.job.toLevel} · ${icon("clock", 12)} <span class="eta">${fmtDuration(pick.remaining)}</span></small>${barHtml(pick.progress, "gold", "thin")}${queueLine ? `<small class="qnext">${queueLine}</small>` : ""}</div>
      ${queueIndex >= 0 ? btnHtml("Queue", "blue", { className: "queue", icon: "clock", data: `data-i="${queueIndex}"` }) : btnHtml("View", "blue", { className: "open" })}`;
  }
  if (pick.kind === "maxed") return `<div class="ic">${icon("builder", 22, "#fff8e6")}</div><div class="text"><b>Everything is maxed</b></div>`;
  const { option } = pick;
  const name = upgradeTargetName(B, option.target, option.towerIndex);
  const why = p.freeBuilders <= 0 ? "No free builder" : option.affordable ? "Builder idle" : "Builder idle · not enough gold";
  return `
    <div class="ic ${pick.actionable ? "idle" : ""}">${icon("builder", 22, "#fff8e6")}</div>
    <div class="text"><b>${why}</b><small>${name} Lv ${option.level} → ${option.level + 1} · ${describeCost(option.cost)} · ${fmtDuration(p.durationFor(option.level + 1))}</small></div>
    ${btnHtml("Upgrade", "blue", { className: "open", disabled: !pick.actionable })}`;
}
